module.exports = __webpack_public_path__ + "static/img/jiejuefangan@1x.fcb6b0c.png";


//////////////////
// WEBPACK FOOTER
// ./static/assets/jiejuefangan@1x.png
// module id = lfiC
// module chunks = 2